module.exports = __webpack_public_path__ + "static/media/teaching_professionalnew.c7bc52c7.svg";